import fitvids from "fitvids";
import LazyLoad from "vanilla-lazyload";

const Common = {
  init() {
    new LazyLoad();

    Common.events();
  },

  events() {
    $(".mobile-lang").on("click", function () {
      $(this).toggleClass("show-mobile-langs");
    });
    // Table
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    // Fitvids
    fitvids();

    // Video.
    $(".flex-video__overlay").on("click", function () {
      $(this).parent().addClass("playing").find("video")[0].play();
    });
  },
};

export default Common;
